<template>
      <el-dialog custom-class="yearDialog" :visible.sync="dialogTableVisible" width="706px" :show-close="false" append-to-body :before-close="handleDialogClose">
            <div class="bigTitle">{{arYear}}年报详情</div>
            <div class="yearBox">
                 <title-year ref="tyear0">
                      <!-- <div class="title">基本信息<span :class="['showMore',{'isOpen':flag == 1}]" @click="showMore('1')">{{flag == 1?'展开':'收起'}}<i class="el-icon-arrow-down"></i></span></div> -->
                      <template slot="titleY">
                            基本信息
                      </template>
                        <div class="table tab-01 tabBase">
                              <el-row>
                                    <el-col :span="7">统一社会信用代码/注册号</el-col>
                                    <el-col :span="17">{{basicInfo.credit_num || '---'}}</el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="7">是否有网站或网店</el-col>
                                    <el-col class="cl1" :span="5">{{basicInfo.ar_store || '---'}}</el-col>
                                    <el-col :span="4" class="cl2">企业经营状态</el-col>
                                    <el-col class="cl3" :span="8">{{basicInfo.status || '---'}}</el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="7">从业人数</el-col>
                                    <el-col class="cl1" :span="5">{{basicInfo.ar_staff_num || '---'}}</el-col>
                                    <el-col :span="4" class="cl2 moreLine">本年度是否发生股东转让</el-col>
                                    <el-col class="cl3" :span="8">{{basicInfo.is_invest || '---'}}</el-col>
                                    
                              </el-row>
                              <el-row>
                                    <el-col :span="7">企业联系电话</el-col>
                                    <!-- <el-col class="cl1 clTel" :span="5">{{basicInfo.tel || '---'}}</el-col> -->
                                    <el-col class="cl1 clTel" :span="5">
                                          <el-tooltip v-if="basicInfo.tel" class="item" effect="light" :content="basicInfo.tel" placement="top">
                                                 <span>{{basicInfo.tel}}</span>
                                          </el-tooltip>
                                          <span v-else>---</span>
                                    </el-col>
                                    <el-col :span="4" class="cl2">电子邮箱</el-col>
                                    <el-col class="cl3 address" :span="8"><p>{{basicInfo.email || '---'}}</p></el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="7" class="moreLine">是否有投资信息或购买其他公司股权</el-col>
                                    <el-col :span="17">{{basicInfo.is_invest || '---'}}</el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="7">企业通信地址</el-col>
                                    <el-col class="address" :span="17"><p>{{basicInfo.ar_add || '---'}}</p></el-col>
                              </el-row>
                        </div>
                 </title-year>
                 <title-year ref="tyear1">
                      <template slot="titleY">
                            股东（发起人）及出资信息
                      </template>
                      <template v-if="shareholderInfo.length>0">
                        <div class="table tab-01" v-for="(item,i) in shareholderInfo" :key="i">
                              <el-row class="row-01">{{item.shareholder}}</el-row>
                              <el-row>
                                    <el-col :span="5">认缴出资时间</el-col>
                                    <el-col :span="7">{{item.subscribed_time | formatTime}}</el-col>
                                    <el-col :span="5">实际出资时间</el-col>
                                    <el-col :span="7">{{item.paid_time | formatTime}}</el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="5">认缴出资额</el-col>
                                    <el-col :span="7">{{item.subscribed_amt || '---'}}</el-col>
                                    <el-col :span="5">实际出资额</el-col>
                                    <el-col :span="7">{{item.paid_capi || '---'}}</el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="5">认缴出资方式</el-col>
                                    <el-col :span="7">{{item.subscribed_fund || '---'}}</el-col>
                                    <el-col :span="5">实际出资方式</el-col>
                                    <el-col :span="7">{{item.paid_fund || '---'}}</el-col>
                              </el-row>
                        </div>
                      </template>
                        <!-- 无数据 -->
                        <template v-else>
                              <div class="noData">
                                    <img src="@/assets/gbIcon/noData.png">
                                    <p>暂无数据</p>
                              </div>
                        </template>
                       
                 </title-year>
                 <title-year ref="tyear2">
                       <template slot="titleY">
                            网站或网店信息
                       </template>
                      
                        <el-table class="tab-02" :data="domin" innerpage>
                              <el-table-column type="index" label="序号" width="136px"></el-table-column>
                              <el-table-column property="web_type" label="类型"></el-table-column>
                              <el-table-column width="225px" property="web_name" label="名称"></el-table-column>
                              <el-table-column label="网址">
                                    <template slot-scope="scope"><el-link :href="scope.row.website" target="_blank" :underline="false">{{scope.row.website}}</el-link></template>
                              </el-table-column>
                        </el-table>
                       
                  </title-year>
                 <title-year ref="tyear3">
                       <template slot="titleY">
                            对外投资信息
                        </template>
                        <el-table class="tab-02" :data="investInfo" innerpage>
                        <el-table-column type="index" label="序号" width="136px"></el-table-column>
                        <el-table-column property="ivested_company_name" label="投资设立或购买股权境内企业名称"></el-table-column>
                        <el-table-column width="198px" property="credit_no" label="统一社会信用代码/注册"></el-table-column>
                        </el-table>
                  
                 </title-year>
                 <title-year ref="tyear4">
                       <template slot="titleY">
                            企业资产状况信息
                        </template>
                        <div class="table tab-01">
                              <el-row>
                                    <el-col :span="5">资产总额</el-col>
                                    <el-col :span="7">{{capital.total_capi || '---'}}</el-col>
                                    <el-col :span="5">所有者权益合计</el-col>
                                    <el-col :span="7">{{capital.owner_share || '---'}}</el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="5">营业总收入</el-col>
                                    <el-col :span="7">{{capital.total_income || '---'}}</el-col>
                                    <el-col :span="5" class="moreLine">营业总收入中主营业务</el-col>
                                    <el-col :span="7">{{capital.main_income || '---'}}</el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="5">利润总额</el-col>
                                    <el-col :span="7">{{capital.total_profit || '---'}}</el-col>
                                    <el-col :span="5">净利润</el-col>
                                    <el-col :span="7">{{capital.net_profit || '---'}}</el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="5">纳税总额</el-col>
                                    <el-col :span="7">{{capital.tax_amt || '---'}}</el-col>
                                    <el-col :span="5">负债总额</el-col>
                                    <el-col :span="7">{{capital.total_debt || '---'}}</el-col>
                              </el-row>
                              
                        </div>
                 </title-year>
                 <title-year ref="tyear5">
                        <template slot="titleY">
                            股权变更信息
                        </template>
                      
                        <div class="process" v-if="stockInformation">
                              <div class="step" v-for="(item,i) in stockInformation" :key="i">
                                    <span class="round"></span>
                                    <div class="txt">
                                          <div class="date">2018/4/12</div>
                                          <div class="des">
                                                <p class="p1">王大二</p>
                                                <p class="p2">
                                                      <span>变更前：45.2</span>
                                                      <span>变更后：90</span>
                                                </p>
                                          
                                          </div>
                                    </div>
                              </div>
                        </div>
                        <!-- 无数据 -->
                        <div class="process" v-else>
                              <div class="noData">
                                    <img src="@/assets/gbIcon/noData.png">
                                    <p>暂无数据</p>
                              </div>
                        </div>
                     
                 </title-year>
                 <title-year ref="tyear6">
                       <template slot="titleY">
                            修改记录
                        </template>
                        <el-table class="tab-02" :data="changeInfo" innerpage >
                        <el-table-column width="136px" property="change_item" label="修改事项"></el-table-column>
                        <el-table-column property="change_before" label="修改前"></el-table-column>
                        <el-table-column property="change_after" label="修改后"></el-table-column>
                         <el-table-column property="change_date" label="修改日期">
                              <!-- <templete slot-scope="scope">
                                    {{scope.row.change_date}}
                              </templete> -->
                        </el-table-column>
                        </el-table>
                 </title-year>
                 <title-year ref="tyear7">
                       <template slot="titleY">
                            对外提供保证担保信息
                        </template>
                      
                        <el-table class="tab-02" :data="provideInformation" innerpage>
                        <el-table-column width="136px" property="date" label="债权人"></el-table-column>
                        <el-table-column property="name" label="主债权种类"></el-table-column>
                        <el-table-column property="address" label="主债权数额"></el-table-column>
                        <el-table-column property="address" label="旅行债务的期限"></el-table-column>
                        <el-table-column property="address" label="保证的期间"></el-table-column>
                        <el-table-column property="address" label="保证的方式"></el-table-column>
                        </el-table>
                     
                  </title-year>
                 <title-year ref="tyear8">
                       <template slot="titleY">
                            社保信息
                        </template>
                        <div class="table tab-3">
                              <el-row>
                                    <el-col :span="7">
                                          参保各险人数
                                    </el-col>
                                    <el-col class="right-col">
                                          <el-row>
                                                <el-col>城镇职工基本养老保险</el-col>
                                                <el-col :span="12">{{socialInsurance.basic_pension || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>失业保险</el-col>
                                                <el-col :span="12">{{socialInsurance.unemploy_ins || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>职工基本医疗保险</el-col>
                                                <el-col :span="12">{{socialInsurance.basic_med_care || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>工伤保险</el-col>
                                                <el-col :span="12">{{socialInsurance.worker_ins || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>生育保险</el-col>
                                                <el-col :span="12">{{socialInsurance.maternity_ins || '---'}}</el-col>
                                          </el-row>
                                    </el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="7">
                                          单位缴费基数
                                    </el-col>
                                    <el-col class="right-col">
                                          <el-row>
                                                <el-col>单位参加城镇职工基本养老保险缴费基数</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_basic_pension || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>单位参加失业保险缴费基数</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_unemploy_ins || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>单位参加职工基本医疗保险缴费基数</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_med_care || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>单位参加工伤保险缴费基数</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_worker_ins || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>单位参加生育保险缴费基数</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_maternity_ins || '---'}}</el-col>
                                          </el-row>
                                    </el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="7">
                                          本期实际缴费金额
                                    </el-col>
                                    <el-col class="right-col">
                                          <el-row>
                                                <el-col>参加城镇职工基本养老保险本期实际缴费金额</el-col>
                                                <el-col :span="12">{{socialInsurance.paid_basic_pension || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>参加失业保险本期实际缴费金额</el-col>
                                                <el-col :span="12">{{socialInsurance.paid_unemploy || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>参加职工基本医疗保险本期实际缴费金额</el-col>
                                                <el-col :span="12">{{socialInsurance.paid_med_care || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>参加工伤保险本期实际缴费金额</el-col>
                                                <el-col :span="12">{{socialInsurance.paid_worker_ins || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>参加生育保险本期实际缴费金额</el-col>
                                                <el-col :span="12">{{socialInsurance.paid_maternity_ins || '---'}}</el-col>
                                          </el-row>
                                    </el-col>
                              </el-row>
                              <el-row>
                                    <el-col :span="7">
                                          单位累计欠缴金额
                                    </el-col>
                                    <el-col class="right-col">
                                          <el-row>
                                                <el-col>单位参加城镇职工基本养老保险累计欠缴金额</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_pension_owe || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>单位参加失业保险累计欠缴金额</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_unemploy_owe || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>单位参加职工基本医疗保险累计欠缴金额</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_med_owe || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>单位参加工伤保险累计欠缴金额</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_worker_owe || '---'}}</el-col>
                                          </el-row>
                                          <el-row>
                                                <el-col>单位参加生育保险累计欠缴金额</el-col>
                                                <el-col :span="12">{{socialInsurance.unit_maternity_owe || '---'}}</el-col>
                                          </el-row>
                                    </el-col>
                              </el-row>
                        </div>
                 </title-year>
            </div>
      </el-dialog>
</template>
<script>
import {parseTime} from '@/base/global'
import moment from 'moment'
import {yearModuleDetail} from '../api/newClueApi'
import titleYear from './titleYear'
export default {
      components:{
            titleYear
      },
      data(){
        return{
           dialogTableVisible:false,
           arYear:'',//年份
           basicInfo:{},//基本信息
           shareholderInfo:[],//股东（发起人）及出资信息
           domin:[],//网站或网店信息
           investInfo:[],//对外投资信息
           capital:{},//企业资产状况信息
           stockInformation:[],//股权变更信息
           changeInfo:[],//修改记录
           provideInformation:[],//对外提供保证担保信息
           socialInsurance:{},//社保信息
           screenHeight:null //窗口的高度
        }
      },
      filters:{
            formatTime(val){
                  if (val) {
                        if (typeof val === 'string') val = val.replace(/-/ig, '/')
                        return parseTime(new Date(val), '{y}-{m}-{d}')
                  }
                  return '--'
            }
      },
      mounted(){
          
            this.screenHeight = document.body.clientHeight
            document.getElementsByClassName('yearDialog')[0].style.height = (this.screenHeight - 80) + 'px'
            // window.onresize = ()=>{
            //              this.screenHeight = document.body.clientHeight
            //              document.getElementsByClassName('yearDialog')[0].style.height = (this.screenHeight - 80) + 'px'
                 
            // }
      },
      methods:{
            handleDialogClose(){
                        this.dialogTableVisible = false
                        for(let i=0;i<9;i++){
                        this.$refs['tyear'+i].reset()
                        }
            },
            showDialog(year,moduleId,hid,companyName){
                  this.dialogTableVisible = true
                  this.getYearModuleDetail(year,moduleId,hid,companyName)
            },
            // 获取数据
            getYearModuleDetail(year,moduleId,hid,companyName){
                  let data ={
                        companyName:companyName,
                        hid:hid,
                        moduleId:moduleId,
                        recordId: hid,
                        year
                  }
                  yearModuleDetail(data).then(res=>{
                        if(res.code == 200){
                              if(res.data){
                                    this.arYear = res.data.ar_year
                                    this.basicInfo = res.data.basicInfo
                                    this.shareholderInfo = res.data.shareholderInfo
                                    this.domin = res.data.domin
                                    this.investInfo = res.data.investInfo
                                    this.capital = res.data.capital
                                    this.stockInformation = res.data.stockInformation //股权变更信息
                                    res.data.changeInfo.forEach(v => {
                                          v.change_date = moment(v.change_date).format('YYYY-MM-DD')
                                    })
                                    this.changeInfo = res.data.changeInfo
                                    this.provideInformation = res.data.provideInformation //对外提供保证担保信息
                                    this.socialInsurance = res.data.socialInsurance
                                    
                                    if(!this.basicInfo){
                                          this.$refs['tyear0'].kData()
                                    }
                                    if(this.shareholderInfo.length == 0){
                                          this.$refs['tyear1'].kData()
                                    }
                                    if(this.domin.length == 0){
                                          this.$refs['tyear2'].kData()
                                    }
                                    if(this.investInfo.length ==0){
                                          this.$refs['tyear3'].kData()
                                    }
                                    if(this.capital.length ==0){
                                          this.$refs['tyear4'].kData()
                                    }
                                    if(!this.stockInformation){
                                          this.$refs['tyear5'].kData()
                                    }
                                    if(this.changeInfo.length == 0){
                                          this.$refs['tyear6'].kData()
                                    }
                                    if(!this.provideInformation){
                                          this.$refs['tyear7'].kData()
                                    }
                                    // if(this.socialInsurance){
                                    //       this.$refs['tyear8'].kData()
                                    // }
                                    if(JSON.stringify(this.socialInsurance) === '{}'){
                                          this.$refs['tyear8'].kData()
                                    }
                              }
                              
                        }
                  })
            }
      }
}
</script>
<style scoped lang="scss">
::v-deep{
     .yearDialog{
      //      height: 600px;
           overflow-y: scroll;
           border-radius: 4px;
           scrollbar-width: none; //兼容火狐浏览器
           &::-webkit-scrollbar{width: 0;display: none;}
           &::-webkit-scrollbar-track{width: 0;display: none;}
           &::-webkit-scrollbar-thumb{width: 0;display: none;}
           &::-webkit-scrollbar-button{width: 0;display: none;}
           &::-webkit-scrollbar-corner{width: 0;display: none;}
           .yearbox{
                 margin-bottom: 74px;
           }
         .el-dialog__header{
               display: none;
         }
         .el-dialog__body{
           padding-right: 32px;
           padding-left: 32px;
           box-sizing: border-box;
         }
         .bigTitle{
               font-weight: 500;
            color: #333333;
            line-height: 33px;
            font-size: 24px;
            text-align: center;
            margin-bottom: 24px;
         }
         .item-box{
               margin-bottom: 30px;
               .title{
                     font-weight: bold;
                        color: #333333;
                        height: 42px;
                        line-height: 42px;
                        background: rgba(187,190,202,0.1);
                        padding-left: 36px;
                        padding-right: 20px;
                        box-sizing: border-box;
                        position: relative;
                        margin-bottom: 16px;
                        &::before{
                              content: '';
                              position: absolute;
                              left: 24px;
                              top: 0;
                              bottom: 0;
                              margin: auto;
                              width: 4px;
                              height: 12px;
                              background: #4286F5;
                              border-radius: 1px;
                              
                        }
                        .showMore{
                              float: right;
                              font-weight: 400;
                              color: #333333;
                              font-size: 13px;
                              cursor: pointer;
                              i{
                                    margin-left: 6px;
                                    -webkit-transition: -webkit-transform .3s;
                                    transition: -webkit-transform .3s;
                                    transition: transform .3s;
                                    transition: transform .3s, -webkit-transform .3s;
                              }
                              &.isOpen .el-icon-arrow-down{
                                    transform: rotate(180deg);
                                    -ms-transform:rotate(180deg); 
                                   -webkit-transform:rotate(180deg);
                              }
                        }
               }
               .tab-01{
                     border: 1px solid #EAEBED;
                     border-bottom: none;
                     border-right: none;
                     margin-bottom: 16px;
                     .el-row{
                            border-bottom: 1px solid #EAEBED;
                            box-sizing: border-box;
                            .el-col{
                                 border-right: 1px solid #EAEBED;
                                 padding: 0 0px 0 13px;
                                 height: 54px;
                                 line-height: 54px;
                                 box-sizing: border-box;
                                 font-weight: 400;
                                 color: #343951;
                                 font-size: 14px;
                                 &.moreLine{
                                       line-height: unset;
                                       padding-top: 7px;
                                 }
                                 &:nth-of-type(1){
                                  background: #FAFAFA;
                                 }
                           }
                           .el-col-5{
                                 background: #FAFAFA;
                           }
                           &.row-01{
                                 line-height: 54px;
                                 height: 54px;
                                 background: #FAFAFA;
                                 padding-left: 13px;
                                 font-weight: 600;
                                 color: #343951;
                                 font-size: 16px;
                                 box-sizing: border-box;
                                 border-right: 1px solid #EAEBED;
                           }
                     }
               }
               .tab-02{
                     .has-gutter{
                           tr{
                                 .cell{
                                    font-weight: bold;
                                    color: #333333;
                                    font-size: 13px;
                                 }
                                 
                           }
                     }
                    th.el-table__cell.is-leaf:nth-of-type(1),.el-table__row td:nth-of-type(1){
                              text-align: left;
                              padding-left: 30px;
                    }
               }
               .tab-3{
                     border-top:1px solid #EAEBED;
                     border-left: 1px solid #EAEBED;
                     .el-row{
                           border-bottom:1px solid #EAEBED;
                           align-items: center;
                              display: flex;
                                  background: #FAFAFA;
                                  .el-col-7{
                                        width: 171px;
                                        padding-left: 13px;
                                        box-sizing: border-box;
                                  }
                              .el-col{
                                    .el-row{
                                          border-bottom: 1px solid #EAEBED;
                                          &:nth-last-of-type(1){
                                                border-bottom: none;
                                          }
                                          .el-col{
                                                 border-right: 1px solid #EAEBED;
                                                 height: 54px;
                                                 line-height: 54px;
                                                 padding-left: 10px;
                                                 box-sizing: border-box;
                                                 background: #fff;
                                          }
                                    }
                              }
                     }
                     .right-col{
                           border-left: 1px solid #EAEBED;
                     }
                     
               }
            //    流程
            .process{
                  padding-top: 8px;
                  padding-left: 30px;
                  box-sizing: border-box;
                  .step{
                        position: relative;
                        border-left: 2px solid rgba(229,233,242,0.7);
                        padding-left: 20px;
                        padding-bottom: 16px;
                        box-sizing: border-box;
                        &:nth-last-of-type(1){
                              border-left: none;
                        }
                        .round{
                              width: 10px;
                              height: 10px;
                              background: #5088FF;
                              display: block;
                              position: absolute;
                              top: 0;
                              left: -6px;
                              border-radius: 50%;
                        }
                        .txt{
                              padding-top: 20px;
                              position: relative;
                              box-sizing: border-box;
                              .date{
                                    font-size: 13px;
                                    font-family: ArialMT;
                                    color: #999999;
                                    line-height: 18px;
                                    position: absolute;
                                    left: 0;
                                    top: -4px;
                              }
                              .des{
                                    background: #FBFBFB;
                                    padding: 16px 32px 10px;
                                    box-sizing: border-box;
                                    .p1{
                                          font-weight: 400;
                                          color: #333333;
                                          font-size: 13px;
                                          margin-bottom: 6px;
                                    }
                                    .p2{
                                          span{
                                                // height: 24px;
                                                // line-height: 24px;
                                                border-radius: 2px;
                                                border: 1px solid #BBBECA;
                                                margin-right: 8px;
                                                font-weight: 400;
                                                color: #555555;
                                                font-size: 12px;
                                                padding: 4px 10px;
                                                box-sizing: border-box;
                                          }
                                    }
                              }
                        }
                  }
            }
         }
         .el-table .el-table__row:nth-child(odd){
               background: none;
         }
         .tab-01{
            &.tabBase{
               border: none;
               border-left: 1px solid #EAEBED;
               .el-row{
                     border-bottom: none;
                     .el-col{
                           padding: 0 10px !important;
                           box-sizing: border-box;
                           &.moreLine{
                                 padding-top: 7px !important;
                           }
                           border-bottom: 1px solid #EAEBED;
                     }
                     &:nth-of-type(1){
                        .el-col{
                              border-top: 1px solid #EAEBED;
                        } 
                     }
                  //    .el-col-8{
                  //       width: 182px;
                  //          background: #FAFAFA;
                  //    }
                  //    .el-col-16{
                  //          width: 459px;
                  //    }
                  //    .el-col-5{
                  //         width: 182px;
                  //          background: #FAFAFA;
                  //          padding: 0 13px !important;
                  //    }
                     .cl1{
                           background: none;
                           &.clTel{
                                 overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                           }
                     }
                     .cl2{
                        //    width: 141px;
                           background: #FAFAFA;
                     }
                  //    .cl3{
                  //          width: 187px;
                  //    }
                     .address{
                         line-height: unset !important;
                        //  padding-top: 7px !important;
                        display: table;
                         p{
                               display: table-cell;
                               vertical-align: middle;
                         }
                     }
               }
            }
         }
         
         .noData{
               text-align: center;
               img{
                     width: 150px;
                     height: 150px;
               }
               p{
                     font-weight: 400;
                     color: #999999;
                     font-size: 14px;
               }
         }
         .packUp{
               .tabbox{
                     display: none;
               }
         }
   }
}
</style>